import { isSupportedLocale, setLocalePreference, useLocalePreference } from "@app/i18n";

/**
 * 로그인 전에는 설정 화면에 들어갈 수 없으므로, 브라우저 언어 감지 결과가 사용자 기대와
 * 어긋났을 때 인증 화면에서 바로 바꿀 수 있게 한다. 세션이 없어 서버 저장
 * (useSaveLocaleMutation)은 못 하고, 로그인 후 useSyncLocaleFromServer 가 서버 값으로
 * 다시 수렴시킨다.
 */
function applyLocale(value: string): void {
  // 지원하는 언어가 아닌지
  const isLocaleInvalid = !isSupportedLocale(value);
  if (isLocaleInvalid) return;
  setLocalePreference(value);
}

/** 세션 없는 인증 화면들이 공유하는 언어 토글. 로컬 선호값만 바꾼다(위 applyLocale 참고). */
export function useLocaleToggle() {
  const locale = useLocalePreference();
  return { locale, onLocaleChange: applyLocale };
}
